export default defineNuxtPlugin((nuxtApp) => {
    if (document.getElementById("produktlyScript")) return

    const clientToken = nuxtApp.$config.public.produktlyClientToken
    const featureEnabled = nuxtApp.$config.public.feature.produktly

    if (!featureEnabled) {
        console.warn("Produktly feature is not enabled")
        return;
    } else if (!clientToken) {
        console.warn("Produktly client token is not defined")
        return;
    }

    const w = window as any

    w.Produktly = w.Produktly || new Proxy(function () {}, {
        get: (_: any, n: string) => (...args: any[]) => {
            w.ProduktlyQ = (w.ProduktlyQ || []).concat([[n, args]])
        },
        apply: (_: any, __: any, args: any[]) => {
            w.ProduktlyQ = (w.ProduktlyQ || []).concat([["apply", args]])
        }
    })

    const script = document.createElement("script")
    script.id = "produktlyScript"
    script.async = true
    script.src = "https://public.produktly.com/js/main.js"
    script.dataset.clientToken = clientToken

    document.head.appendChild(script)
})
